import React, { useContext } from 'react';
import { MainContext } from '../../context/MainContext';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';

import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';

const DIP_CONFIG = [
  { id: 0, label: '1', r3Index: 10 },
  { id: 1, label: '2', r3Index: 11 },
  { id: 2, label: '3', r3Index: 12 },
  { id: 3, label: '4', r3Index: 13 },
  { id: 4, label: '5', r3Index: 14 },
  { id: 5, label: '6', r3Index: 15 },
];

export default function DashboardDipSwitches() {
  const state = useContext(MainContext).state;
  const r3 = state.R3?.split(',') ?? [];

  const dips = DIP_CONFIG.map((item) => ({
    ...item,
    isOn: r3[item.r3Index] === '1',
  }));

  const phasesValue = r3[2];

  return (
    <React.Fragment>
      <Typography
        component="h2"
        variant="h6"
        color="white"
        gutterBottom
        sx={{ fontWeight: 600 }}
      >
        Dip Switches
      </Typography>

      <Grid container spacing={1.5}>
        {dips.map((dip) => (
          <Grid item xs={6} key={dip.id}>
            <Paper
              sx={{
                p: 1.2,
                height: 60,
                display: 'flex',
                alignItems: 'center',
                gap: 1.2,
                borderRadius: 2,
                bgcolor: 'rgba(255, 255, 255, 0.04)',
                border: '1px solid',
                borderColor: 'rgba(255,255,255,0.1)',
                transition: 'all 0.2s ease',
                '&:hover': {
                  bgcolor: 'rgba(255,255,255,0.08)',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              <Box
                sx={{
                  width: 30,
                  height: 30,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: dip.isOn
                    ? 'success.main'
                    : 'rgba(255, 255, 255, 0.05)',
                  color: dip.isOn ? '#000' : 'rgba(50,116,162,1)',
                  flexShrink: 0,
                }}
              >
                <TuneOutlinedIcon fontSize="small" />
              </Box>

              <Box
                sx={{
                  flexGrow: 1,
                  minWidth: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  gap: 0.3, 
                  mt: 0.4
                }}
              >
                <Typography
                  color="white"
                  sx={{
                    fontSize: 14,
                    fontWeight: 700,
                    lineHeight: 1.1,
                  }}
                  noWrap
                >
                  DIP {dip.label}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 13,
                    color: dip.isOn ? 'success.main' : 'text.disabled',
                  }}
                >
                  {dip.isOn ? 'On' : 'Off'}
                </Typography>
              </Box>
            </Paper>
          </Grid>
        ))}

        <Grid item xs={12}>
          <Paper
            sx={{
              p: 1.5,
              mt: 0.5,
              height: 52,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              borderRadius: 2.5,
              bgcolor: 'rgba(255, 255, 255, 0.04)',
              border: '1px solid rgba(255,255,255,0.1)',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
              <Box
                sx={{
                  width: 32,
                  height: 32,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  bgcolor: 'rgba(33, 150, 243, 0.9)',
                  color: '#000',
                }}
              >
                <SettingsInputComponentIcon fontSize="small" />
              </Box>
              <Box>
                <Typography
                  color="white"
                  sx={{ fontWeight: 700, fontSize: 14, }}
                >
                  Phases
                </Typography>
              </Box>
            </Box>

            <Typography
              variant="h6"
              sx={{
                color: 'white',
                fontWeight: 700,
                letterSpacing: 0.5,
                minWidth: 40,
                textAlign: 'right',
                fontSize: 15,
              }}
            >
              {phasesValue ?? '—'}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
